import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["dimmed"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import styled from 'styled-components';
import { pxToRem } from 'utils/ui/units';
import { spacing, breakpoints } from 'styles/globals';
import { swing } from 'styles/animations';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var Wrapper = styled.div.withConfig({
  shouldForwardProp: function shouldForwardProp(prop) {
    return prop !== 'dimmed';
  }
}).withConfig({
  displayName: "Spinner__Wrapper",
  componentId: "sc-13nar4j-0"
})(["position:relative;display:inline-block;margin:0 auto;padding-top:", ";padding-bottom:", ";font-size:", ";", " @media (min-width:", "){font-size:", ";}@media (min-width:", "){font-size:", ";}"], spacing.s, spacing.s, pxToRem(6), function (p) {
  return p.dimmed && "\n\t\topacity: 0.5;\n\t";
}, breakpoints.s, pxToRem(8), breakpoints.m, pxToRem(10));
var Dot = styled.div.withConfig({
  displayName: "Spinner__Dot",
  componentId: "sc-13nar4j-1"
})(["display:inline-block;width:1em;height:1em;color:inherit;background-color:currentColor;border-radius:10rem;font-size:inherit;animation:", " 0.4s infinite linear alternate;& + &{margin-left:0.5em;}&:nth-child(2){animation-delay:-0.1s;}&:nth-child(3){animation-delay:-0.2s;}"], swing);
var Spinner = function Spinner(_ref) {
  var _ref$dimmed = _ref.dimmed,
    dimmed = _ref$dimmed === void 0 ? false : _ref$dimmed,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsxs(Wrapper, _objectSpread(_objectSpread({}, otherProps), {}, {
    dimmed: dimmed,
    children: [/*#__PURE__*/_jsx(Dot, {}), /*#__PURE__*/_jsx(Dot, {}), /*#__PURE__*/_jsx(Dot, {})]
  }));
};
export default Spinner;